import { ResolverRegistry } from '@packages/form-engine';
import type { ConditionContext } from '@packages/form-engine';
import { validateCriteriaTree } from '@packages/domain/shared/rule-builder/helpers';

ResolverRegistry.registerValidation(
  'taxSetupUserDefinedCriteria',
  (value: unknown, _formData: Record<string, unknown>, _ctx: ConditionContext) => {
    const errors = validateCriteriaTree(value);
    if (errors.Conditions) {
      return 'Required Field';
    }
    return null;
  },
);
